import Tooltip from '@mui/material/Tooltip';
import CakeIcon from '@mui/icons-material/Cake';
import LocalBarIcon from '@mui/icons-material/LocalBar';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import LocalActivityIcon from '@mui/icons-material/LocalActivity';
import LocalPizzaIcon from '@mui/icons-material/LocalPizza';
import dayjs from 'dayjs';

function UpgradeSymbols({ upgrades = [], manualUpgrades = [], voucherSoldDate }) {
  const shownUpgrades = [...upgrades, manualUpgrades];

  return (
    <>
      {voucherSoldDate && voucherSoldDate !== null ? (
        <Tooltip title={dayjs(voucherSoldDate).format('[Gekauft:] DD.MM.YYYY HH:mm')}>
          <LocalActivityIcon sx={{ color: 'lightgrey' }} />
        </Tooltip>
      ) : (
        ''
      )}
      {shownUpgrades.includes('childBirthday') ? <CakeIcon sx={{ color: 'orange' }} /> : ''}
      {shownUpgrades.includes('childBirthdayFull') ? <CakeIcon sx={{ color: 'red' }} /> : ''}
      {shownUpgrades.includes('teenBirthday') ? <CakeIcon sx={{ color: 'green' }} /> : ''}
      {shownUpgrades.includes('adultBirthday') ? <CakeIcon /> : ''}
      {shownUpgrades.includes('bachelorParty') ? <LocalBarIcon sx={{ color: 'lightblue' }} /> : ''}
      {shownUpgrades.includes('bag') ? <ShoppingBagIcon sx={{ color: 'yellow' }} /> : ''}
      {shownUpgrades.includes('pizza') ? <LocalPizzaIcon sx={{ color: 'brown' }} /> : ''}
    </>
  );
}

export default UpgradeSymbols;
